import { uiText } from "@loom/shared/brand";

import { useT } from "../../i18n/index.js";
import { Banner } from "../../ui/Banner";

interface ErrorToastProps {
  readonly message: string;
  readonly terminal: boolean;
}

export function ErrorToast({ message, terminal }: ErrorToastProps) {
  const t = useT();
  return (
    <Banner tone="error">
      {terminal ? t("chatRender.sessionEnded") : ""}
      {/* The server's own text: under the UI public-name mode its "Loom"
          shows as the public name. */}
      {uiText(message)}
    </Banner>
  );
}
